
import { Component, Vue, Ref } from 'vue-property-decorator'
import { EnterpriseService } from '@/services'
import PrTable from '../components/prTable.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import FullLoading from '@/components/full_loading/index.vue'

@Component({
    name: 'pr-cert',
    components: {
        PrTable,
        ScrollTo,
        FullLoading
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private prList = []
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0
    private isLoading = false
    private loadingText = ''
    private status = -1
    private statusOptions = [
        { label: '所有申请', value: -1 },
        { label: '审核中', value: 0 },
        { label: '通过', value: 1 },
        { label: '不通过', value: 2 }
    ]


    private async mounted() {
        this.showLoading()
        await Promise.all([
            this.getPrList()
        ])
        this.hideLoading()
    }

    /** 获取机构列表 */ 
    private async getPrList() {
        const status = this.status === -1 ? undefined : this.status
        const params = {
            status: status,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await EnterpriseService.getPrCertList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.prList = result.data.list
        }
    }   

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getPrList)
    }

    private showLoading() {
        this.isLoading = true
    }

    private hideLoading() {
        this.isLoading = false
    }
}
